// ANSI color code to CSS class mapping
const ANSI_COLORS: Record<number, string> = {
  30: 'ansi-black', 31: 'ansi-red', 32: 'ansi-green', 33: 'ansi-yellow',
  34: 'ansi-blue', 35: 'ansi-magenta', 36: 'ansi-cyan', 37: 'ansi-white',
  90: 'ansi-bright-black', 91: 'ansi-bright-red', 92: 'ansi-bright-green', 93: 'ansi-bright-yellow',
  94: 'ansi-bright-blue', 95: 'ansi-bright-magenta', 96: 'ansi-bright-cyan', 97: 'ansi-bright-white',
};

const ANSI_BG_COLORS: Record<number, string> = {
  40: 'ansi-bg-black', 41: 'ansi-bg-red', 42: 'ansi-bg-green', 43: 'ansi-bg-yellow',
  44: 'ansi-bg-blue', 45: 'ansi-bg-magenta', 46: 'ansi-bg-cyan', 47: 'ansi-bg-white',
  100: 'ansi-bg-bright-black', 101: 'ansi-bg-bright-red', 102: 'ansi-bg-bright-green', 103: 'ansi-bg-bright-yellow',
  104: 'ansi-bg-bright-blue', 105: 'ansi-bg-bright-magenta', 106: 'ansi-bg-bright-cyan', 107: 'ansi-bg-bright-white',
};

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function parseAnsi(text: string): string {
  // First escape HTML to prevent XSS
  let result = escapeHtml(text);

  // Match ANSI escape sequences: ESC[ followed by params and ending with 'm'
  // ESC can be \x1b, \u001b, or \033
  // eslint-disable-next-line no-control-regex
  const ansiRegex = /\x1b\[([0-9;]*)m/g;

  let openTags = 0;
  result = result.replace(ansiRegex, (_, codes) => {
    if (!codes || codes === '0') {
      // Reset - close all open tags
      const closeTags = '</span>'.repeat(openTags);
      openTags = 0;
      return closeTags;
    }

    const codeList = codes.split(';').map(Number);
    const classes: string[] = [];

    for (const code of codeList) {
      if (code === 0) {
        // Reset handled above
      } else if (code === 1) {
        classes.push('ansi-bold');
      } else if (code === 2) {
        classes.push('ansi-dim');
      } else if (code === 3) {
        classes.push('ansi-italic');
      } else if (code === 4) {
        classes.push('ansi-underline');
      } else if (ANSI_COLORS[code]) {
        classes.push(ANSI_COLORS[code]);
      } else if (ANSI_BG_COLORS[code]) {
        classes.push(ANSI_BG_COLORS[code]);
      }
    }

    if (classes.length > 0) {
      openTags++;
      return `<span class="${classes.join(' ')}">`;
    }
    return '';
  });

  // Close any remaining open tags
  result += '</span>'.repeat(openTags);

  return result;
}
